module.exports = __webpack_public_path__ + "static/media/h2.729ec2e0.svg";